import { EventImpl } from '@/types/Course'
import React from 'react'

function EventDate({
  event,
  className = '',
}: {
  event: EventImpl
  className?: string
}) {
  let locale = 'en-US'
  if (typeof navigator !== 'undefined' && navigator.language) {
    try {
      new Intl.DateTimeFormat(navigator.language)
      locale = navigator.language
    } catch {}
  }

  const timeFormatOptions: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  }

  return (
    <p className={`font-normal text-grays-dark ${className}`}>
      {event.startDateTime.toLocaleDateString(locale)} |{' '}
      {event.startDateTime.toLocaleTimeString(locale, timeFormatOptions)}{' '}
      -{' '}
      {event.endDateTime.toLocaleTimeString(locale, timeFormatOptions)}
    </p>
  )
}

export default EventDate
